import { Action, Reducer } from 'redux';
import {
  DistributionRegionState,
  DistributionRegionTypes,
  DistributionRegionActionTypes
} from './distributionRegionTypes';

export const INITIAL_STATE: DistributionRegionState = {
  distributionRegion: {
    data: null,
    errorMessages: null,
    isError: false,
    isLoading: false
  }
};

const distributionRegionReducer: Reducer<DistributionRegionState> = (
  state: DistributionRegionState = INITIAL_STATE,
  action: Action
) => {
  const actionTypes = action as DistributionRegionActionTypes;
  switch (actionTypes.type) {
    case DistributionRegionTypes.GET_DISTRIBUTION_REGION:
      return {
        ...state,
        distributionRegion: { ...state.distributionRegion, isLoading: true }
      };
    case DistributionRegionTypes.SAVE_DISTRIBUTION_REGION:
      return {
        ...state,
        distributionRegion: {
          ...state.distributionRegion,
          isLoading: false,
          errorMessages: actionTypes.payload.errorMessages,
          isError: actionTypes.payload.isError,
          data: actionTypes.payload.data
        }
      };
    case DistributionRegionTypes.RESET_REDUCER_DISTRIBUTION_REGION:
      return {
        ...state,
        distributionRegion: INITIAL_STATE.distributionRegion
      };
    default:
      return state;
  }
};

export default distributionRegionReducer;
